/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { termControllerFindAll } from '../fn/term/term-controller-find-all';
import { TermControllerFindAll$Params } from '../fn/term/term-controller-find-all';
import { termControllerFindByType } from '../fn/term/term-controller-find-by-type';
import { TermControllerFindByType$Params } from '../fn/term/term-controller-find-by-type';
import { termControllerUpdate } from '../fn/term/term-controller-update';
import { TermControllerUpdate$Params } from '../fn/term/term-controller-update';
import { TermDto } from '../models/term-dto';

@Injectable({ providedIn: 'root' })
export class TermService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `termControllerFindAll()` */
  static readonly TermControllerFindAllPath = '/api/term';

  /**
   * 약관 전체 조회.
   *
   * 전체 약관을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  termControllerFindAll$Response(params?: TermControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TermDto>>> {
    return termControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 약관 전체 조회.
   *
   * 전체 약관을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termControllerFindAll(params?: TermControllerFindAll$Params, context?: HttpContext): Observable<Array<TermDto>> {
    return this.termControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TermDto>>): Array<TermDto> => r.body)
    );
  }

  /** Path part for operation `termControllerFindByType()` */
  static readonly TermControllerFindByTypePath = '/api/term/{type}';

  /**
   * 약관 타입 기반 조회.
   *
   * 약관을 타입 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termControllerFindByType()` instead.
   *
   * This method doesn't expect any request body.
   */
  termControllerFindByType$Response(params: TermControllerFindByType$Params, context?: HttpContext): Observable<StrictHttpResponse<TermDto>> {
    return termControllerFindByType(this.http, this.rootUrl, params, context);
  }

  /**
   * 약관 타입 기반 조회.
   *
   * 약관을 타입 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termControllerFindByType$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  termControllerFindByType(params: TermControllerFindByType$Params, context?: HttpContext): Observable<TermDto> {
    return this.termControllerFindByType$Response(params, context).pipe(
      map((r: StrictHttpResponse<TermDto>): TermDto => r.body)
    );
  }

  /** Path part for operation `termControllerUpdate()` */
  static readonly TermControllerUpdatePath = '/api/term/{type}';

  /**
   * 약관 타입 기반 수정.
   *
   * 약관을 타입 기반으로 수정합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `termControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  termControllerUpdate$Response(params: TermControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<TermDto>> {
    return termControllerUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * 약관 타입 기반 수정.
   *
   * 약관을 타입 기반으로 수정합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `termControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  termControllerUpdate(params: TermControllerUpdate$Params, context?: HttpContext): Observable<TermDto> {
    return this.termControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<TermDto>): TermDto => r.body)
    );
  }

}
